import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useLocation, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
  Modal,
  Collapse,
  Progress,
} from "reactstrap"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"
import SweetAlert from "react-bootstrap-sweetalert"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

import { Button } from "@material-ui/core"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const Campaign = props => {
  const query = useQuery()
  const history = useHistory()

  const [token, setToken] = useState(null)
  const [uid, setUid] = useState(null)
  const [cid, setCid] = useState(null)
  const [shareCodeMessage, setShareCodeMessage] = useState(
    props.t("Share your code")
  )
  const [currency, setCurrency] = useState("")
  const [isGuest, setIsGuest] = useState(false)

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }

    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setUid(obj.member_id)
      console.log(obj)
    } else {
      setIsGuest(true)
    }

    if (localStorage.getItem("currency")) {
      setCurrency(localStorage.getItem("currency"))
    }

    if (query.get("id")) {
      setCid(query.get("id"))
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token != null) {
      if (!isGuest) {
        getUserProfile()
      }
      getCampaign()
      console.log("use effect")
    }
  }, [token])

  const [userData, setUserData] = useState(null)
  const getUserProfile = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_profile")
    urlencoded.append("member_id", uid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request category", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setUserData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [campaignData, setCampaignData] = useState(null)
  const getCampaign = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_campaign")
    if (!isGuest) urlencoded.append("member_id", uid)
    urlencoded.append("campaign_id", cid)

    // urlencoded.append("member_id", 58)
    // urlencoded.append("campaign_id", 8)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request get campaign", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setCampaignData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const redeemCampaign = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "redeem_campaign_reward")
    urlencoded.append("member_id", uid)
    urlencoded.append("campaign_id", cid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request redeem campaign", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      alert(postresponse.message)
      redirectAfterRedeem(campaignData.reward_type, postresponse.product_id)
      getCampaign()
    } else {
      // seterror_alert(true)
    }
  }

  function redirectAfterRedeem(reward_type, pid) {
    switch (reward_type) {
      case "product_free":
        history.push("/vouchers")
        break
      case "product_discount":
        history.push("/product-details?id=" + pid)
        break
      case "points":
        history.push("/profile")
        break
    }
  }

  const [modal_tnc, setmodal_tnc] = useState(false)

  function tog_tnc() {
    setmodal_tnc(!modal_tnc)
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  const [redirect_alert, setredirect_alert] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            {redirect_alert ? (
              <SweetAlert
                title={dynamic_title}
                onCancel={() => {
                  setredirect_alert(false)
                }}
                customButtons={<React.Fragment></React.Fragment>}
              >
                <React.Fragment>
                  <Row className="px-3 py-2">
                    <button
                      className="btn btn-primary waves-effect waves-light font-size-15 me-2"
                      onClick={() => {
                        setredirect_alert(false)
                        history.push("/login")
                      }}
                    >
                      {props.t("Login")}
                    </button>
                  </Row>
                  <Row className="px-3 py-2">
                    <button
                      className="btn btn-light waves-effect waves-light font-size-15"
                      onClick={() => {
                        setredirect_alert(false)
                      }}
                    >
                      {props.t("Cancel")}
                    </button>
                  </Row>
                </React.Fragment>
              </SweetAlert>
            ) : null}
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  paddingTop: "56px",
                  backgroundColor: "#E5E5E5",
                  paddingBottom: "76px",
                }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "56px",
                        backgroundColor: "#009FE2",
                        position: "fixed",
                        top: 0,
                        zIndex: 1030,
                        maxWidth: "480px",
                      }}
                    >
                      <Col xs={2} className="ps-0">
                        {/* <Link to="/categories"> */}
                        <Button
                          className="h-100 m-0"
                          onClick={() => {
                            history.goBack()
                          }}
                        >
                          <i className="bx bx-arrow-back align-middle font-size-20 text-white" />
                        </Button>
                        {/* </Link> */}
                      </Col>
                      <Col xs={8} className="align-self-center">
                        <p className="h-100 text-white font-size-15 my-auto text-center">
                          {props.t("Campaign")}
                        </p>
                      </Col>
                      <Col xs={2} className="pe-0">
                        {/* <Link to="#">
                          <Button className="h-100 m-0">
                            <i className="bx bx-basket align-middle font-size-28 text-white" />
                          </Button>
                        </Link> */}
                      </Col>
                    </Row>
                    {campaignData && (
                      <Row>
                        <Col>
                          <Card
                            className="mb-0 p-3"
                            style={{
                              borderRadius: "0px",
                              // width: "160px",
                              // height: "196px",
                              backgroundColor: "white",
                            }}
                          >
                            <CardImg
                              top
                              className="img-fluid"
                              src={campaignData.image}
                              alt=""
                              style={{
                                aspectRatio: "3/2",
                                objectFit: "cover",
                                borderRadius: "14px",
                              }}
                            />
                          </Card>
                        </Col>
                      </Row>
                    )}
                    {campaignData &&
                      campaignData.campaign_type == "task_based" && (
                        <Row className="p-3">
                          <Col>
                            <CardTitle className="font-size-20">
                              {props.t("Campaign Progress")}
                            </CardTitle>
                          </Col>
                        </Row>
                      )}
                    {campaignData &&
                      campaignData.campaign_type == "task_based" && (
                        <Row>
                          <Col>
                            <Card
                              className="p-3 shadow-none mb-3"
                              style={{
                                borderRadius: "0px",
                                // width: "160px",
                                // height: "196px",
                                backgroundColor: "white",
                              }}
                            >
                              <Row className="mb-2">
                                <Col>
                                  <span className="font-size-15 text-primary">
                                    <strong>
                                      {campaignData.campaign_progress
                                        .percentage + "%"}
                                    </strong>
                                  </span>
                                </Col>
                                <Col xs="auto">
                                  <span className="font-size-15 text-secondary">
                                    {
                                      campaignData.campaign_progress
                                        .campaign_progress_message
                                    }
                                  </span>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <Progress
                                    color="primary"
                                    value={
                                      campaignData.campaign_progress.percentage
                                    }
                                  />
                                </Col>
                              </Row>
                            </Card>
                          </Col>
                        </Row>
                      )}
                    {campaignData && (
                      <Row>
                        <Col>
                          <Card
                            className="p-3 shadow-none"
                            style={{
                              borderRadius: "0px",
                              // width: "160px",
                              // height: "196px",
                              backgroundColor: "white",
                            }}
                          >
                            <Row>
                              <Col>
                                <CardTitle className="font-size-20">
                                  {campaignData.name}
                                </CardTitle>
                              </Col>
                            </Row>
                            <Row className="mt-3">
                              <Col xs="auto">
                                <span className="font-size-14">
                                  <strong>{props.t("Description")}</strong>
                                </span>
                              </Col>
                            </Row>
                            <Row>
                              <Col xs="auto">
                                <span
                                  className="font-size-14"
                                  dangerouslySetInnerHTML={{
                                    __html: campaignData.description,
                                  }}
                                ></span>
                              </Col>
                            </Row>
                            <hr
                              style={{
                                color: "#EAEAEA",
                                backgroundColor: "#EAEAEA",
                                height: "2px",
                              }}
                            />
                            <Row
                              onClick={() => {
                                tog_tnc()
                              }}
                            >
                              <Col>
                                <span className="font-size-15 text-dark">
                                  {props.t("Terms & Conditions")}
                                </span>
                              </Col>
                              <Col xs="auto">
                                <Row>
                                  <Col>
                                    <i
                                      className="bx bx-cookie align-middle font-size-20"
                                      style={{ color: "#A5A5A5" }}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <hr
                              style={{
                                color: "#EAEAEA",
                                backgroundColor: "#EAEAEA",
                                height: "2px",
                              }}
                            />
                          </Card>
                        </Col>
                      </Row>
                    )}
                    {campaignData &&
                      campaignData.is_redeem &&
                      campaignData.task_type != "new_app" && (
                        <Row
                          className="m-0 w-100"
                          style={{
                            height: "76px",
                            backgroundColor: "#ffffff",
                            position: "fixed",
                            bottom: 0,
                            zIndex: 1030,
                            maxWidth: "480px",
                            boxShadow:
                              "0 -0.75rem 1.5rem rgba(18, 38, 63, 0.03)",
                          }}
                        >
                          <Col className="h-100 p-0">
                            <Card body className="mb-0 p-3">
                              <Row>
                                <Col>
                                  <button
                                    className={
                                      campaignData.is_redeemed
                                        ? "btn btn-light waves-effect waves-light font-size-18 w-100 text-muted"
                                        : "btn btn-primary waves-effect waves-light font-size-18 w-100"
                                    }
                                    // style={{ height: "42px" }}
                                    onClick={() => {
                                      if (!isGuest) redeemCampaign()
                                      else {
                                        setredirect_alert(true)
                                        setdynamic_title(
                                          props.t(
                                            "Welcome, please login to continue"
                                          )
                                        )
                                      }
                                    }}
                                    disabled={campaignData.is_redeemed}
                                  >
                                    {campaignData.is_redeemed
                                      ? props.t("Redeemed")
                                      : props.t("Redeem")}
                                  </button>
                                </Col>
                              </Row>
                            </Card>
                          </Col>
                        </Row>
                      )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={modal_tnc}
        toggle={() => {
          tog_tnc()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            {props.t("Terms & Conditions")}
          </h5>
          <button
            type="button"
            onClick={() => {
              setmodal_tnc(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div
          className="modal-body"
          dangerouslySetInnerHTML={
            campaignData && {
              __html: campaignData.terms_and_conditions,
            }
          }
        ></div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              tog_tnc()
            }}
            className="btn btn-secondary waves-effect"
            data-dismiss="modal"
          >
            {props.t("Close")}
          </button>
          {/* <button
            type="button"
            className="btn btn-primary waves-effect waves-light"
          >
            Save changes
          </button> */}
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default withTranslation()(Campaign)

Campaign.propTypes = {
  t: PropTypes.any,
}
